import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { HttpClient } from '../configs/axios.config';
import { AchievementModel } from '../interfaces/models/AchievementModel';
import { Api } from './Api';

@injectable()
export class AchievementApi implements Api {

    constructor(
        public api: HttpClient
    ) {}

    getAchievements(): AxiosPromise<AchievementModel[]> {
        return this.api.client.get<AchievementModel[]>(`/achievement/list/`);
    }

}
